// extracted by mini-css-extract-plugin
export var contentBody = "_cs-9";
export var headerImage = "_cs-2";
export var imageButton = "_cs-7";
export var imageButtonIcon = "_cs-8";
export var imageHeader = "_cs-4";
export var imageHeaderText = "_cs-5";
export var imageOverlay = "_cs-3";
export var imageTitle = "_cs-6";
export var imageWrapper = "_cs-1";
export var taskList = "_cs-a";
export var widget = "_cs-0";